'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Mask = require('../../managewidgets/components/mask/Mask');

var _Mask2 = _interopRequireDefault(_Mask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaskManager = function MaskManager(props) {
  if (props.showMask) {
    return _react2.default.createElement(
      _Mask2.default,
      null,
      props.children
    );
  } else {
    return null;
  }
};

MaskManager.propTypes = {
  showMask: _propTypes2.default.bool.isRequired
};

exports.default = MaskManager;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/mask/MaskManager.js
// module id = 329
// module chunks = 10